import { initializeBrowserMonitoring } from './browserErrors';

initializeBrowserMonitoring({
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true' && !import.meta.env.SSR,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  release: import.meta.env.VITE_APP_RELEASE,
});
